export const getValueByIdFromUrl = (key: string, url: string): string => {
  // const url = new URL(path);

  // const value = url.searchParams.get(key) || '';

  // return value;
  const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const regex = new RegExp(`[?&]${escapedKey}=([^&]*)`);

  const match = url.match(regex);

  return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
};
